import styled from "@emotion/styled";
import SkapaLoading, {
  LoadingBall,
  type LoadingBallProps,
} from "@ingka/loading";

interface LoadingProps extends LoadingBallProps {
  text?: string;
}

export const Loading = ({ text, ...rest }: LoadingProps) => {
  return (
    <SkapaLoading prefix="saleslead__" text={text}>
      <LoadingBall prefix="saleslead__" {...rest} />
    </SkapaLoading>
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgb(218 218 218 / 81%);
`;

export const LoadingOverlay = ({ text }: LoadingProps) => {
  return (
    <Overlay>
      <Loading text={text} />
    </Overlay>
  );
};
